import { extend } from 'acorn-jsx-walk'
import { base, simple } from 'acorn-walk'

import { t } from '../ast/utils'

import type { TransformOptions } from '../transform'
import type { AnyNode, Literal } from 'acorn'

extend(base)

export function extractImportModules(
  node: AnyNode,
  _options: TransformOptions = {}
): Literal[] {
  const moduleImports: Literal[] = []
  simple(node, {
    ImportDeclaration(node) {
      if (t.isLiteral(node.source)) {
        moduleImports.push(node.source)
      }
    },
    ImportExpression(node) {
      if (t.isLiteral(node.source)) {
        moduleImports.push(node.source)
      }
    }
  })
  return moduleImports
}
